import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Gender } from '@app/shared/enums/gender.enum';
import { ICountry } from '@app/shared/models';
import { CountryService } from '@app/shared/services/country/country.service';
import { inOutAnimation } from '@app/shared/utils';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';

@Component({
  selector: 'app-customer-data-form',
  templateUrl: './customer-data-form.smart.component.html',
  styleUrls: ['./customer-data-form.smart.component.scss'],
  animations: [inOutAnimation],
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }]
})
export class CustomerDataFormSmartComponent implements OnInit, OnDestroy {

  @Input() showFields: boolean;
  @Input() emailInputDisabled: boolean;
  @Input() passwordInputVisible: boolean;
  @Input() showCheckboxDontCreateAccount: boolean;
  @Input() remarksInputVisible: boolean;
  @Input() isFormSubmitted: boolean;

  public readonly parentFormDirective = inject(FormGroupDirective);
  public readonly countryService = inject(CountryService);
  public parentForm: BookingStepsFormType;
  public Gender = Gender;
  public countries: ICountry[];
  private masterSubscription = new Subscription();

  ngOnInit(): void {
    this.parentForm = this.parentFormDirective.form;
    this.loadCountries();
    this.makePasswordsInputDisabledOrEnabled();
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  public selectGender(gender: Gender): void {
    this.parentForm.controls.customerData.controls.gender.setValue(gender);
  }

  public compareCountryCodes(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  public get customerDataControl() {
    return this.parentForm.controls.customerData.controls;
  }

  private loadCountries(): void {
    const sub = this.countryService.getAllCountries()
      .subscribe((countries: ICountry[]) => {
        this.countries = countries;
        const defaultValue = this.countries.find(country => country.twoLetterIsoCode === 'NL');
        this.customerDataControl.country.patchValue(this.customerDataControl.country.value ? this.customerDataControl.country.value : defaultValue);
      });
    this.masterSubscription.add(sub);
  }

  private makePasswordsInputDisabledOrEnabled(): void {
    this.parentForm.controls.createAnAccount.valueChanges.subscribe(value => {
      if (value) {
        this.parentForm.controls.password.disable();
        this.parentForm.controls.passwordRepeat.disable();
      } else {
        this.parentForm.controls.password.enable();
        this.parentForm.controls.passwordRepeat.enable();
      }
    });
  }
}
